import React, { useState } from 'react';
import axios from 'axios';

const ContactUs: React.FC = () => {
  const [agree, setAgree] = useState(false);
  const [requestSent, setRequestSent] = useState(false);
  const [serverState, setServerState] = useState({
    submitting: false,
    status: { ok: null, msg: null },
  });

  const handleServerResponse = (ok: any, msg: any, form: any) => {
    setServerState({
      submitting: false,
      status: { ok, msg },
    });
    if (ok) {
      form.reset();
    }
  };

  const handleCheckClick = () => {
    setAgree(!agree);
  };

  const handleOnSubmit = (e: any) => {
    e.preventDefault();
    const form = e.target;
    setServerState({ submitting: true, status: { ok: null, msg: null } });
    axios({
      method: 'post',
      url: 'https://getform.io/f/22ca6e09-94c4-4fa8-9e10-add23452e268', //url: 'https://getform.io/f/4d2ea115-4c46-49d0-81be-4afdf1ba153d',
      data: new FormData(form),
    })
      .then(r => {
        handleServerResponse(true, 'Thanks!', form);
      })
      .catch(r => {
        handleServerResponse(false, r.response.data.error, form);
      });
  };

  return (
    <section
      id='contact-us'
      className='flex flex-col items-center justify-center mx-10 my-10 bg-white md:space-x-10'
    >
      <div className='flex md:flex-row flex-col'>
        {/* Image Container */}
        <div className='mb-4 md:mb-0 md:p-6'>
          <img className='m-auto' alt='' src={'/group.svg'} />
        </div>

        {/* Form Container */}
        <div className='max-w-2xl border bg-[#fafafa] rounded-md p-6 mx-auto md:border-none md:bg-white md:p-4'>
          <form
            id='contact-form'
            onSubmit={handleOnSubmit}
            className='flex flex-col items-center justify-center'
          >
            {/* Title */}
            <div className='flex flex-col items-center justify-center w-full mb-5 text-center md:text-left md:mb-6'>
              <h2 className='mb-4 text-3xl font-bold'>
                Connect With Our Sales Team
              </h2>
              <p className='w-auto mx-auto'>
                Our team is here to support your goals and strategic vision. 
              </p>
            </div>

            {/* Inputs */}
            <div className='grid items-center justify-center w-full grid-cols-2 mx-2 my-5 gap-x-6 gap-y-6'>
              {/* First Name */}
              <label className='hidden' htmlFor='first-name'>
                Enter your first name.
              </label>
              <input
                className='w-full rounded-md border border-[#7f9e85] focus:bg-[#d5ffde] px-5 py-3 mb-0 duration-100 hover:border-[#b0fcc0]'
                type='text'
                id='first-name'
                name='first-name'
                placeholder='First Name'
                autoComplete='given-name'
                required
              />

              {/* Last Name */}
              <label className='hidden' htmlFor='last-name'>
                Enter your last name.
              </label>
              <input
                className='flex flex-row justify-start rounded-md border border-[#7f9e85] focus:bg-[#d5ffde] px-5 py-3 duration-100 hover:border-[#b0fcc0]'
                type='text'
                id='last-name'
                name='last-name'
                placeholder='Last Name'
                autoComplete='family-name'
              />

              {/* Email */}
              <label className='hidden' htmlFor='email'>
                Enter your email address.
              </label>
              <input
                className='flex flex-row justify-start rounded-md border border-[#7f9e85] focus:bg-[#d5ffde] px-5 py-3 mb-0 duration-100 hover:border-[#b0fcc0]'
                type='email'
                id='email'
                name='email'
                placeholder='Email Address'
                required
              />

              {/* Phone */}
              <label className='hidden' htmlFor='phone'>
                Enter your phone number.
              </label>
              <input
                className='justify-start rounded-md border border-[#7f9e85] focus:bg-[#d5ffde] px-5 py-3 duration-100 hover:border-[#b0fcc0]'
                type='text'
                id='phone'
                name='phone'
                placeholder='Phone'
              />
            </div>
            <input
              className='flex flex-col self-start justify-start rounded-md border border-[#7f9e85] focus:bg-[#d5ffde] px-5 pt-2 pb-20 w-full duration-100 hover:border-[#b0fcc0]'
              placeholder='Your Text'
            />

            <div className='flex flex-row w-full my-4 space-x-5'>
              <input
                type='checkbox'
                className='w-7 h-7 form-checkbox rounded checked:text-[#7f9e85] placeholder:text-[#7f9e85] focus:outline-[#7f9e85]'
                title='I agree that CheQRboard may contact me at the email address or phone number above.'
                id='agree'
                checked={agree}
                onChange={handleCheckClick}
              />
              <label
                htmlFor='agree'
                className='text-xs self-center text-[#7f9e85]'
              >
                I agree that CheQRboard may contact me at the email address or
                phone number above.
              </label>
            </div>

            {/* Submit Button */}
            {!requestSent ? (
              <button
                disabled={serverState.submitting || !agree}
                className='flex flex-row justify-center items-center rounded-md bg-[#333215] text-white px-10 py-5 w-full disabled:bg-[rgba(51,50,21,0.5)] disabled:cursor-not-allowed duration-150 hover:bg-[#89F5A0] hover:text-[#333215] hover:font-semibold hover:shadow-lg'
              >
                Submit
              </button>
            ) : (
              <div className='flex flex-row justify-center items-center rounded-md text-[#333215] border border-[#7f9e85]'>
                <p className='px-20 py-4 font-semibold'>
                  We'll be in touch soon!
                </p>
              </div>
            )}
          </form>
        </div>
      </div>
      {/* Request a Demo */}
      <div className='flex flex-row items-center justify-center my-[8rem] !ml-0'>
        {/* Request Demo Button */}
        <a
          href='https://share.hsforms.com/1vQT5Dh5IQg6q5d23tBcocwr7uug'
          rel='noopener'
          target='_blank'
          className='flex flex-row rounded-full bg-[#89F5A0] text-[#333215] font-bold py-[2rem] px-[4rem] items-center my-6 text-xl md:self-start duration-150 hover:bg-[#333215] hover:text-[#89F5A0] hover:font-semibold hover:shadow-lg'
        >
          <span className='leading-6'>Request a Demo</span>
        </a>
      </div>
      <div className="flex flex-col text-center relative bg-[#CBD9FF] w-[90%] h-auto py-[6rem] px-[4rem] !m-0 rounded-2xl">
        <div className='absolute top-[2rem] left-[2rem]'>
          <img src="/double-quotes.svg" alt="" />
        </div>
        <div className="text-[2rem] mb-[3rem]">
          "Creating content in CheQRboard is so simple! The ready-to-go templates let us build beautifully arranged content in minutes with no formal training. 
        </div>
        <div className="text-[2rem] mb-[3rem]">
          With just a two-person team, we launched our first Trivia Game in a couple of hours and have already enhanced our visitor experience significantly.”
        </div>
        <div className="text-[1.6rem] font-semibold">
          Leah Dunkle
        </div>
        <div className="text-[1.6rem]">
          Museum Executive Coordinator
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
